
import { pdMixin } from '@/mixin/pd/pdMixin'
import SwiperWrap from '@/components/pd/common/SwiperCmp.vue'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  components: {
    CommonImage,
    SwiperWrap
  },
  mixins: [pdMixin],
  props: {
    loadIdx: {
      type: Number,
      default: 0
    },
    banr: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sm: {
      type: Boolean,
      default: false
    },
    position: { // 상품 상세 GTM 수집을 위한 배너의 위치 (상단: top, 중단: mid)
      type: String,
      default: ''
    },
  },
  data () {
    return {
      banrList: [],
      banrOpt: {
        auto: true,
        loop: true,
        navigation: true,
        pagination: true,
      },
    }
  },
  computed: {},
  created () {
    if (this.sm) {
      this.banrOpt.navigation = false
    }
  },
  mounted () {
    this.banrList = []
    this.banr.data.details.forEach((banr) => {
      const obj = {
        imgUrl: this.replaceImg(banr.pcomIconAtchFileUrl), // pc banner url
        name: banr.banrRplcTextNm, // 배너 명
        link: banr.pcomLinkUrl, // pc 이동 링크
        banrLinkMvmnTyCd: banr.banrLinkMvmnTyCd // 배너링크이동유형
      }
      this.banrList.push(obj)
    })
  },
  methods: {
    moveLink (link, banrLinkMvmnTyCd) {
      console.log('banrLinkMvmnTyCd ===', banrLinkMvmnTyCd)
      if (this.isNotEmpty(link)) {
        if (banrLinkMvmnTyCd === '02') {
          window.open(link)
        } else {
          this.$router.push(link)
        }
      }
    }
  }
}
